import { VARIABLE_NAMES } from "../variable-constants";
import { SettingsConfig } from "../settings-type";

const sandboxSettings: Partial<SettingsConfig> = {
  [VARIABLE_NAMES.VARIABLE_TO_TEST_WITH]: "sandbox",
  [VARIABLE_NAMES.FAVICON_COLOR]: "gold",
};

export default sandboxSettings;
